<div *ngIf="!hideTitlebar" class="twc-d-flex layer-selection-text">
    <span>{{'LAYER_SELECT.SELECT_EXISTING' | translate}}</span>
    <twc-icon class="new-layer-close-icon" shape="close" (click)="onClose()">
    </twc-icon>
</div>

<div class="twc-mt-2 twc-mb-3">
    {{selectExistingLayerService.getLayerTypeText() | translate}}
</div>

<div class="height-100">

    <cw-object-browser class="select-layer-browser" [browserViews]="browserViews" [data]="currentData$ | async" [loading]="loading" dataType="layers"
        [isMultiSelection]="isMultiSelection" [shouldShowCheckboxes]="hasToShowCheckbox" [columnDataList]="columnsTable"
        (filterChange)="filterChanged($event)" (pageChange)="pageChanged($event)" (dataRefresh)="dataRefreshed()"
        [footerSelectionResources]="footerSelectionResources" [pagination]="(pagination$ | async) ?? defaultPagination"
        (elementSelect)="onLayerClicked()">
    </cw-object-browser>
</div>